import { ScriptTextIcon } from './ScriptTextIcon';

/**
 * author: Michael Irigoyen
 * id 100A6987-09AC-4A60-B6D6-E9DA1E4FCBCE
 * name script-text
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/script-text.svg
 * tags
 * - Gaming / RPG 
 */
export const ScrollTextIcon = ScriptTextIcon;
export default ScrollTextIcon